import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp";
import { NotificationHelper } from "../core/util/notificationHelper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Sheet, SheetEventType } from "../../siteManagement/sheet";
import { General } from "../../siteManagement/general";
import { ReportMetaDataHelper } from "./reportMetaDataHelper";
import { RoleViewModel } from "./signatureGrid";
import { Helper } from "../core/util/helper";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";
export default class EditRole extends React.Component<EditRoleProps, any> {
    common = new AppHelper();
    private sheet: Sheet;
    constructor(props: any) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this.sheet = General.Sheet.Manager.getTopMostVisibleSheet();
    }

    private validate = () => {
        if (!ReportMetaDataHelper.dictionaryContainsAtLeastEntry(this.props.entity.Name)) {
            NotificationHelper.showWarningMessage(this.props.context.translations["WebSMS.ReportMetadata.NameIsMissing"])
            return false;
        } else {
            return true;
        }
    }

    save = () => {
        if (this.validate()) {
            HTTPService.post<JsonResultClass<any>>("ReportMetaData/CreateNewSignaturRole", { name: this.props.entity.Name, wellknownsigneerole: this.props.entity.WellKnownSigneeRole }).then((result) => {
                let closeAfterSave = false;
                switch (result.Code) {
                    case 0:
                        let data: RoleViewModel = {
                            Key: result.Data.Key,
                            Value: result.Data.Value,
                            WellKnownSigneeRole: this.props.entity.WellKnownSigneeRole
                        }
                        this.sheet.trigger(SheetEventType.Custom, { cmd: "afterSuccessfullySave", data: data });
                        closeAfterSave = true;
                        break;
                    case 1:
                        NotificationHelper.showErrorMessage(result.Message)
                        break;
                }
                this.common.handlePostSave(result.Code === 0, closeAfterSave);
                this.setState({});
            })
        }
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    componentDidMount() {
        this.common.updateSheetTitle(Helper.getTranslation("WebCRM.Administration.NewRole"))
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} titleProps={this.props.title} />;
    }
}

export interface EditRoleProps extends AppBaseProps{
    entity: Role;
    context: EditRoleContext;
}

export interface Role extends Entity {
    Name: {};
    WellKnownSigneeRole?: WellKnownSigneeRole;
}

export enum WellKnownSigneeRole {
    Technician = 1,
    Customer = 2,
    Dispatcher = 3
}

export interface EditRoleContext extends Context {
    translations: StringKeyDictionary<string>
}

